/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockItemManageShareCtrl
 */
angular.module('mercury.modules.stock.item')
.controller('StockItemManageShareCtrl', ["dialog", "$filter", "itemId", "$q", "$rootScope", "$scope", "StockSharedItems", "userinfo", function(dialog, $filter, itemId, $q, $rootScope, $scope, StockSharedItems, userinfo) {
  $scope.globalPrice = 'GlobalPrice';

  $scope.items = StockSharedItems.get(itemId);

  $scope.activeCompanies = userinfo.avaliableCompanies();

  var updateUnsharedCompanies = function() {
    $scope.unsharedCompanies = [];
    angular.forEach($scope.activeCompanies, function(company) {
      if ($filter('filter')($scope.items, {sharedCompanyId: company.id}).length === 0 && !company.subscriptionDenied) {
        $scope.unsharedCompanies.push({id: company.id, name: company.name});
      }
    });
  };

  $scope.loading = $q.all([$scope.items.$promise]);
  $scope.loading.then(function() {
    // Only display active companies
    $scope.items = $filter('filter')($scope.items, function(item) {
      return $scope.activeCompanies[item.sharedCompanyId] != null;
    });
    // Order the items so the current company is on top, then alphabetical.
    $scope.items = $filter('orderBy')($scope.items, [
      function(item) {
        return item.sharedCompanyId == userinfo.activeCompany() ? 0 : 1;
      },
      'sharedCompanyShortName'
    ]);

    updateUnsharedCompanies();
  });

  $scope.linkItem = function(companyId) {
    $scope.$close();
    dialog.open({
      templateUrl: 'modules/stock/item/share.tpl.html',
      controller: 'StockItemShareCtrl',
      resolve: {
        itemIds: function() {
          return [itemId];
        },
        companyId: function() {
          return companyId;
        }
      }
    });
  };

  $scope.unitSearch = function(sharedItem, searchStr) {
    return StockSharedItems.searchCompanyUnits(sharedItem.sharedCompanyId, searchStr);
  };

  $scope.supplierSearch = function(sharedItem, searchStr) {
    return StockSharedItems.searchCompanySuppliers(sharedItem.sharedCompanyId, searchStr);
  };

  $scope.orderingUnitUpdated = function(sharedItem) {
    StockSharedItems.patchCompanyItem(
      sharedItem.sharedStockItemId,
      'OrderingUnitId',
      sharedItem.sharedStockItemOrderingUnitId,
      sharedItem.sharedCompanyId
    ).then(function() {
      if (sharedItem.sharedCompanyId == userinfo.activeCompany()) {
        $rootScope.$broadcast('manageSharedItemUpdated', {
          id: itemId,
          orderingUnitId: sharedItem.sharedStockItemOrderingUnitId,
          orderingUnitName: sharedItem.sharedStockItemOrderingUnitName,
          orderingUnitRatio: sharedItem.sharedStockItemOrderingUnitRatio
        });
      }
    });
  };

  $scope.countingUnitUpdated = function(sharedItem) {
    StockSharedItems.patchCompanyItem(
      sharedItem.sharedStockItemId,
      'CountingUnitId',
      sharedItem.sharedStockItemCountingUnitId,
      sharedItem.sharedCompanyId
    ).then(function() {
      if (sharedItem.sharedCompanyId == userinfo.activeCompany()) {
        $rootScope.$broadcast('manageSharedItemUpdated', {
          id: itemId,
          countingUnitId: sharedItem.sharedStockItemCountingUnitId,
          countingUnitName: sharedItem.sharedStockItemCountingUnitName
        });
      }
    });
  };

  $scope.defaultSupplierUpdated = function(sharedItem) {
    StockSharedItems.patchCompanyItem(
      sharedItem.sharedStockItemId,
      'DefaultSupplierId',
      sharedItem.sharedStockItemDefaultSupplierId,
      sharedItem.sharedCompanyId
    ).then(function() {
      if (sharedItem.sharedCompanyId == userinfo.activeCompany()) {
        $rootScope.$broadcast('manageSharedItemUpdated', {
          id: itemId,
          defaultSupplierId: sharedItem.sharedStockItemDefaultSupplierId,
          defaultSupplierName: sharedItem.sharedStockItemDefaultSupplierName
        });
      }
    });
  };

  // updates all items
  $scope.syncPrices = function(sharedItem) {
    StockSharedItems.patchSharedItemsPrice(sharedItem.sharedStockItemId, sharedItem.sharedStockItemCurrentPrice).then(function() {
      angular.forEach($scope.items, function(item) {
        item.sharedStockItemCurrentPrice = sharedItem.sharedStockItemCurrentPrice;
      });
    });
  };

  // this will only be called if the price has changed
  $scope.priceUpdated = function(sharedItem, index) {
    if ($scope.sharedItemManage['currentPrice' + index].$invalid) {
      return;
    }

    // make all prices match if we want to sync
    if (sharedItem.syncGlobalPrice) {
      $scope.syncPrices(sharedItem);
    } else {
      // or just update the one item
      StockSharedItems.patchCompanyItem(
        sharedItem.sharedStockItemId,
        $scope.globalPrice,
        sharedItem.sharedStockItemCurrentPrice,
        sharedItem.sharedCompanyId
      );
    }

    if (sharedItem.sharedCompanyId == userinfo.activeCompany()) {
      $rootScope.$broadcast('manageSharedItemUpdated', {
        id: itemId,
        globalPrice: sharedItem.sharedStockItemCurrentPrice
      });
    }

  };

  $scope.nameUpdated = function() {
    if ($scope.sharedItemManage.name.$invalid) {
      return;
    }

    StockSharedItems.patchCompanyItem(
      $scope.items[0].sharedStockItemId,
      'Name',
      $scope.items[0].sharedStockItemName,
      $scope.items[0].sharedCompanyId
    ).then(function() {
      $rootScope.$broadcast('manageSharedItemUpdated', {
        id: itemId,
        name: $scope.items[0].sharedStockItemName
      });
    });
  };

  // changed from syncGlobalPriceChange
  $scope.syncLatestPriceChange = function() {
    StockSharedItems.update($scope.items[0])
    .then(function() {
      if ($scope.items[0].syncGlobalPrice) {
        $scope.syncPrices($scope.items[0]);
      }
    });
  };

  $scope.deleteSharedItem = function(sharedItem, index) {
    StockSharedItems.patchCompanyItem(
      sharedItem.sharedStockItemId,
      'DatestampRemoved',
      moment().format(),
      sharedItem.sharedCompanyId
    ).then(function() {
      if (sharedItem.sharedCompanyId == userinfo.activeCompany()) {
        $rootScope.$broadcast('manageSharedItemUpdated', {
          id: itemId,
          isShared: false,
          datestampRemoved: moment().format()
        });
        $scope.$close();
      } else {
        $scope.items.splice(index, 1);

        // There is only 1 shared item left, so it is no longer shared.
        if ($scope.items.length == 1) {
          $rootScope.$broadcast('manageSharedItemUpdated', {
            id: itemId,
            isShared: false
          });
          $scope.$close();
        }
      }

      updateUnsharedCompanies();
    });
  };
}]);
